export default function onSelectDown(event, editor, next) {
  var _editor$value = editor.value,
      anchorBlock = _editor$value.anchorBlock,
      focusBlock = _editor$value.focusBlock,
      selection = _editor$value.selection;

  if (selection.isSet) {
    event.preventDefault();
    event.stopPropagation();
    return editor.selectTableCellRange({
      start: anchorBlock,
      end: focusBlock
    });
  } else if (selection.isUnset) {
    event.preventDefault();
    event.stopPropagation();

    var _editor$getTableSelec = editor.getTableSelectRange(),
        endCell = _editor$getTableSelec.endCell;

    var newEndCell = editor.getCellBelow(endCell);
    if (!newEndCell) return true;
    return editor.selectTableCellRange({
      end: newEndCell
    });
  }

  return next();
}